import React from "react";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";
import { connect } from 'react-redux';
import { useTranslation } from "react-i18next";
import {
  Collapse,
  Navbar,
  Nav,
  Container,
  Button
} from "reactstrap";

const WikiNavBar = (props) => {
  const { t } = useTranslation(['wiki']);
  let history = useHistory();
  const getBtn = () => {
    if (!props.apiResponsed) {
      return;
    }
    return (<motion.div initial={{ opacity: 0.5, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
        <Button className="installAddon" color="info" onClick={() => history.push("/home")}>
          {t('navBar.home')}
        </Button>
        {props.logged === true && <Button className="installAddon" color="info" onClick={() => history.push("/dashboard")}>
          {t('navBar.panel')}
        </Button>}
      </motion.div>

    );
  }
  return (
    <div className="WikiNavBar">
      <Navbar className="navbar transparent" expand="lg">
          <Container fluid>
              <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>RustLink {t('wiki')}</motion.div>
              <Collapse navbar>
                  <Nav className="ml-auto" navbar>
                    {/*<Button className="installAddon" color="info" onClick={() => history.push("/home")}>
                      {t('navBar.home')}
                    </Button>
                    <Button className="installAddon" color="info" onClick={() => history.push("/dashboard")}>
                        {t('navBar.panel')}
                    </Button>*/}
                    {getBtn()}
                  </Nav>
              </Collapse>
          </Container>
      </Navbar>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { logged, apiResponsed } = state.rLink;
  return { logged, apiResponsed };
};

export default connect(mapStateToProps)(WikiNavBar);